import React, { useState, useEffect, useContext, useCallback } from 'react';
import axios from 'axios';
import { path } from 'ramda';

axios.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        //config.headers['Content-Type'] = 'application/json';
        return config;
    },
        error => {
        return Promise.reject(error);
    }
);

// axios.interceptors.response.use(response => {
//     return response;
//   }, error => {
//     if (error.response && error.response.status === 401) {
//         localStorage.clear();
//     }
//     return Promise.reject(error);
//   });

export const ContentContext = React.createContext({});

export const ContentProvider = ({ children }) => {

    const [ quiz, setQuiz ] = useState(null);
    const [ products, setProducts ] = useState(null);
    const [ provinces, setProvinces ] = useState([]);
    const [ menu, setMenu ] = useState({});
    const [ qrResult, setQrResult ] = useState(null);
    const [ goto, setGoto ] = useState("");
    const [ productLoaded, setProductLoaded ] = useState(null);
    const [ isLoged, setIsLoged ] = useState(false);
    const [ gamesCompleted, setGamesCompleted ] = useState(null);
    const [ quizCompleted, setQuizCompleted ] = useState([]);
    const [ experienceStatus, setExperienceStatus ] = useState(null);
    const [ productId, setProductId ] = useState(null);
    const [ experienceLoaded, setExperienceLoaded ] = useState(null);
    
    //const [ wheel, setWheel ] = useState(null);
    
    const getMenu = () => {

        const menu = {
            dashboard:{
                id: 0,
                label: "Dashboard",
                url: "/dashboard",
                icon: {component: null, custom: false},
                subcategories: {}
            },
            analitycs:{
                id: 1,
                label: "Análisis",
                url: "/analisis",
                icon: {component: null, custom: false},
                subcategories: {
                    laying_houses: {
                        id: 11,
                        label: "Galpones",
                        component: "",
                        url: "/analisis/galpones",
                        icon: {component: null, custom: false},
                    },
                }
            },
            products:{
                id: 2,
                label: "Productos",
                component: "",
                url: "/productos",
                icon: {component: null, custom: false},
                subcategories: {
                    laying_houses: {
                        id: 21,
                        label: "Galpones",
                        component: "",
                        url: "/productos/galpones",
                        icon: {component: null, custom: false},
                    },
                    laying_houses_wieght: {
                        id: 22,
                        label: "Peso",
                        component: "",
                        url: "/productos/galpones/peso",
                        icon: {component: null, custom: false},
                    },
                }
            },
        };

        setMenu(menu);
        
    }

    const getData = useCallback(async () => {

        const requestURL = `${process.env.REACT_APP_BASE_URL}/data.php`;
        //const result = await axios.get(requestURL, { params: filter });
        try {

            const result = await axios.get(requestURL);
            const data = path(['data'], result);
            console.log("data", data)
            if(data){
                setProvinces(data.provinces);
                setProducts(data.products);
                setGamesCompleted(data.games_completed);
                //setExperienceStatus(data.experiences_status);

                let experiences_completed = [];
                data.experiences_status.map(exp => {
                    experiences_completed.push(exp.product_id);
                })
                setExperienceStatus(experiences_completed);

                let quiz_completed = [];
                data.games_completed.map(game => {
                    quiz_completed.push(game.quiz_id);
                })
                setQuizCompleted(quiz_completed);
            }

            return result;

        } catch (error) {

        }

    }, []);

    const getProvinces = useCallback(async () => {

        const requestURL = `${process.env.REACT_APP_BASE_URL}/getProvinces.php`;
        //const result = await axios.get(requestURL, { params: filter });
        try {

            const result = await axios.get(requestURL);
            const data = path(['data'], result);

            if(data){
                setProvinces(data.provinces);
            }

            return result;

        } catch (error) {

        }

    }, []);
    
    
    const login = useCallback(async (payload) => {

        const requestURL = `${process.env.REACT_APP_BASE_URL}/login.php`;
        const params = new URLSearchParams()
        
        if(Object.keys(payload).length){
            Object.keys(payload).map(function(key) {
                params.append(key, payload[key]);
            })
        }

        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        const result = await axios.post(requestURL, params, config);
        const data = path(['data'], result);
        if(data.success){
            setIsLoged(true);
            localStorage.setItem('token', data.token);
        }
        return result;

    }, []);

    const logout = useCallback(async (payload) => {
        //localStorage.setItem('token', "");
        setIsLoged(false);
        localStorage.clear();
    })

    const register = useCallback(async (payload) => {

        const requestURL = `${process.env.REACT_APP_BASE_URL}/register.php`;
        const params = new URLSearchParams()
        
        if(Object.keys(payload).length){
            Object.keys(payload).map(function(key) {
                params.append(key, payload[key]);
            })
        }

        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        const result = await axios.post(requestURL, params, config);
        return result;

    }, []);

    const forgot = useCallback(async (payload) => {

        const requestURL = `${process.env.REACT_APP_BASE_URL}/forgot.php`;
        const params = new URLSearchParams()
        
        if(Object.keys(payload).length){
            Object.keys(payload).map(function(key) {
                params.append(key, payload[key]);
            })
        }

        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        const result = await axios.post(requestURL, params, config);
        return result;

    }, []);

    const change_password = useCallback(async (payload) => {

        const requestURL = `${process.env.REACT_APP_BASE_URL}/change_password.php`;
        const params = new URLSearchParams()
        
        if(Object.keys(payload).length){
            Object.keys(payload).map(function(key) {
                params.append(key, payload[key]);
            })
        }

        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        const result = await axios.post(requestURL, params, config);
        return result;

    }, []);

    const getWheel = useCallback(async (product_id) => {
        
        const requestURL = `${process.env.REACT_APP_BASE_URL}/getWheel.php`;
        //const result = await axios.get(requestURL, { params: filter });
        try {

            const result = await axios.get(requestURL, { params: {product_id: product_id} });
            const data = path(['data', 'wheel'], result);
            /*
            if(data){
                //console.log("data", data.data);
                setWheel(data);
            }
            */
            return result;

        } catch (error) {

        }

    }, []);
    
    const saveWheel = useCallback(async (payload) => {

        const requestURL = `${process.env.REACT_APP_BASE_URL}/saveWheel.php`;
        const params = new URLSearchParams()
        
        if(Object.keys(payload).length){
            Object.keys(payload).map(function(key) {
                params.append(key, payload[key]);
            })
        }

        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        const result = await axios.post(requestURL, params, config);
        return result;

    }, []);

    const getQuiz = useCallback(async (quiz_id, product_id) => {
        
        const requestURL = `${process.env.REACT_APP_BASE_URL}/getQuiz.php`;
        //const result = await axios.get(requestURL, { params: filter });
        try {

            const result = await axios.get(requestURL, { params: {quiz_id: quiz_id, product_id: product_id} });
            const data = path(['data', 'quiz'], result);

            if(data){
                setQuiz(data);
            }

            return result;

        } catch (error) {

        }

    }, []);

    const saveQuiz = useCallback(async (payload) => {

        const requestURL = `${process.env.REACT_APP_BASE_URL}/saveQuiz.php`;
        const params = new URLSearchParams()
        
        if(Object.keys(payload).length){
            Object.keys(payload).map(function(key) {
                params.append(key, payload[key]);
            })
        }

        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        const result = await axios.post(requestURL, params, config);
        return result;

    }, []);

    const saveSubscription = useCallback(async (payload) => {

        const requestURL = `${process.env.REACT_APP_BASE_URL}/saveSubscription.php`;
        const params = new URLSearchParams()
        
        if(Object.keys(payload).length){
            Object.keys(payload).map(function(key) {
                params.append(key, payload[key]);
            })
        }

        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }
        const result = await axios.post(requestURL, params, config);
        return result;

    }, []);
    
    useEffect(() => {

        //getData();
        
        return () => {}
      }, [])

    useEffect(() => {

      if(localStorage.getItem("token")){
        getData();
        setIsLoged(true);
      }else{
        setExperienceStatus(null);
        setIsLoged(false);
      }
    
      return () => {}
    }, [localStorage.getItem("token")])
    

     
    

    return(
        <ContentContext.Provider
            value={{
                login,
                logout,
                register,
                forgot,
                change_password,
                getMenu,
                getQuiz,
                getProvinces,
                saveQuiz,
                saveSubscription,
                quiz, setQuiz,
                provinces,
                menu, setMenu,
                products, setProducts,
                getWheel,
                saveWheel,
                qrResult, setQrResult,
                goto, setGoto,
                productLoaded, setProductLoaded,
                isLoged, setIsLoged,
                gamesCompleted, setGamesCompleted,
                quizCompleted, setQuizCompleted,
                experienceStatus, setExperienceStatus,
                productId, setProductId,
                experienceLoaded, setExperienceLoaded
            }}
        >
            {children}
        </ContentContext.Provider>
    )
};
